import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import PostsCommon from './PostsCommon';

const PostsV2 = (props) => {
  const history = useHistory();
  const params = useParams();

  useEffect(() => {
    if (props.match.params.postId) {
      const postId = parseInt(params.postId);
      if (isNaN(postId) || postId < 1) {
        history.replace("/posts")
      }
    }
  }, [props, params.postId, history])

  return (
    <PostsCommon title="All Posts" />
  )
}

export default PostsV2;